
import {Component, Vue} from 'vue-property-decorator';
import {swalError, swalSuccess} from '@/plugins/swal';

@Component
export default class VerificationMail extends Vue {
  isLoading = true;

  get token() {
    return this.$route.params.token;
  }
  get user_id() {
    return this.$route.params.user_id;
  }

  mounted() {
    this.fecth();
  }

  async fecth() {
    try {
      const res = await this.$store.dispatch('auth/checkVerification', {
        verified_code: this.token,
        user_id: this.user_id,
      });
      if (res.status === 200) {
        swalSuccess.fire({
          title: res.data.message,
          text: 'Your account has been used, please login again',
        });
        this.$router.push('/auth/login');
      } else {
        swalError.fire({
          title: 'Failed!',
          text: res.message,
        });
        this.$router.push('/auth/login');
      }
    } catch (e) {
      this.$router.push('/auth/login');
      swalError.fire({
        title: 'Failed!',
        text:
          e.response?.error?.message ||
          'Sebuah kesalahan yang tidak diduga telah terjadi.',
      });
    }
  }
}
